import { Popover, Transition } from '@headlessui/react';
import { useState } from 'react';

const PopoverHelper = ({ authors, children, isMoreThanTwoAuthors, bgColor, textColor }: any) => {
  const [isShowing, setIsShowing] = useState(false);

  return (
    <div className="relative flex items-center">
      {isMoreThanTwoAuthors ? (
        <Popover
          className="relative cursor-pointer"
          onMouseEnter={() => setIsShowing(true)}
          onMouseLeave={() => setIsShowing(false)}
        >
          {children}
          <Transition
            show={isShowing}
            enter="transition duration-100 ease-out"
            enterFrom="transform scale-95 opacity-0"
            enterTo="transform scale-100 opacity-100"
            leave="transition duration-75 ease-out"
            leaveFrom="transform scale-100 opacity-100"
            leaveTo="transform scale-95 opacity-0"
          >
            <Popover.Panel
              style={{
                ...(bgColor && {
                  backgroundColor: bgColor,
                  borderColor: bgColor,
                }),
              }}
              className="absolute left-0 top-2 flex w-60 flex-col space-y-2 rounded-sm border border-gray-100 px-2 py-4 shadow-sm focus:outline-none"
            >
              {authors.map((author: any) => {
                return (
                  <div key={author.id} className="flex items-center space-x-2 rounded px-2 py-1">
                    <div className="h-5 w-5 overflow-hidden rounded-full">
                      <img
                        key={author.id}
                        className="w-full"
                        src={author.profile_picture.thumb.url}
                        loading={'lazy'}
                        alt={`Profile thumb for author ${author.name}`}
                      />
                    </div>
                    <span
                      style={{
                        ...(textColor && { color: textColor }),
                      }}
                      className="-mb-0.5 whitespace-nowrap text-xs text-gray-700"
                    >
                      {author.name}
                    </span>
                  </div>
                );
              })}
            </Popover.Panel>
          </Transition>
        </Popover>
      ) : (
        <div>{children}</div>
      )}
    </div>
  );
};

export default PopoverHelper;
